export enum CmdToolsetType {
	SELL,
	RENT
} 